import { ArrowForward } from "@mui/icons-material";
import { Box, Button, Link, Typography } from "@mui/material";
import { getStyles } from "src/styles/theme";
import defaultStyles, { StylesClasses } from "./styles";

const MEETING_LINK = "https://meet.google.com/bvp-ywbn-neu";
const QR_IMAGE_URL = `https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${encodeURIComponent(
  MEETING_LINK
)}`;

const MeetingQr = () => {
  const styles = getStyles<StylesClasses>(defaultStyles);

  return (
    <Box {...styles("container")}>
      <Box {...styles("contentWrapper")}>
        <Box {...styles("textSection")}>
          <Typography variant="h5" {...styles("title")}>
            Join Training-cum-Doubt Clearing Session
          </Typography>

          <Typography component="span" {...styles("hindiTitle")}>
            प्रशिक्षण एवं शंका समाधान सत्र में शामिल हों
          </Typography>

          <Typography variant="body2" {...styles("englishDescription")}>
            The revised methodology for the calculation and issuance of Green
            Credits, along with the Guidelines for Eco-Restoration of Degraded
            Forest Land under the Green Credit Programme, were notified on
            29.08.2025 and 01.09.2025, respectively. To facilitate better
            understanding and address queries related to the revised modalities
            and the Green Credit Programme, please participate in the scheduled
            training-cum-doubt-clearing sessions.
          </Typography>

          <Box {...styles("hindiDescriptionBox")}>
            <Typography variant="body2" {...styles("hindiDescription")}>
              “ग्रीन क्रेडिट की गणना एवं निर्गमन हेतु संशोधित कार्यप्रणाली तथा
              अवनत वन भूमि के पारिस्थितिक पुनर्स्थापन के दिशा-निर्देश क्रमशः
              29.08.2025 एवं 01.09.2025 को अधिसूचित किए गए हैं। बेहतर समझ तथा
              शंका/स्पष्टीकरण के समाधान हेतु निर्धारित प्रशिक्षण-सह-शंका-निवारण
              सत्रों में सहभागिता करने का अनुरोध है।”
            </Typography>
          </Box>
        </Box>

        <Box {...styles("qrSection")}>
          <Typography variant="body2" {...styles("schedule")}>
            <strong>Schedule: 11:00 AM</strong>
            <br />
            <Box component="span" {...styles("scheduleHighlight")}>
              English Session – Every Monday and Friday
            </Box>
            <br />
            <Box component="span" {...styles("scheduleHighlight")}>
              हिंदी सत्र – प्रत्येक बुधवार
            </Box>
            <br />
            <Box component="span" {...styles("scheduleNote")}>
              (प्रातः 11:00 बजे)
            </Box>
          </Typography>

          <Box
            component="img"
            src={QR_IMAGE_URL}
            alt="QR code for the training session"
            {...styles("qrImage")}
          />

          <Typography variant="body2" {...styles("scanText")}>
            Scan or click to join
          </Typography>

          <Link
            href={MEETING_LINK}
            target="_blank"
            rel="noopener noreferrer"
            {...styles("meetingLink")}
          >
            meet.google.com/bvp-ywbn-neu
          </Link>

          <Button
            href={MEETING_LINK}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            endIcon={<ArrowForward />}
            {...styles("joinButton")}
          >
            Join Session
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MeetingQr;
